module.exports = __webpack_public_path__ + "static/img/15.00d874c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/15.png
// module id = aW4Z
// module chunks = 1